const ENTRY_CARD_TYPE_ID = "8e8d392fd58d42c1880463e7675adcc3";

function selectAavisaHotProducts(products) {
  return (products || [])
    .filter(product =>
      product.VisaTypeId !== ENTRY_CARD_TYPE_ID &&
      String(product.VisaTitle || "").indexOf("入境卡") === -1
    )
    .slice(0, 8);
}

module.exports = {
  selectAavisaHotProducts,
};



// WEBPACK FOOTER //
// ./src/hotProducts.js